import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import { SCREENINGS_API } from '../env.config.js';
import { locationAddressFieldNames } from '@unite-us/client-utils';
import createFhirBundle from '../utils/fhirMapper.js';
import { SUBMISSION_TIMEOUT_MS } from '../utils/submissionErrors';

const createClientScreening = async (token, pdfFile, providerId, template_codes= [], requestData) => {
  const { screening, screening: { requestor }, template } = requestData;

  function getLoincCode(questionId, optionId = null) {
      const question = template_codes.find(q => q.id === questionId);
      if (!question) {
          return null;
      }

      if (optionId) {
          const option = question.option_codes.find(opt => opt.id === optionId);
          return option ? option.loinc_code : null;
      }

      return question.loinc_code;
  }

  function getOptionTextById(questionId, optionId) {
      const elements = template.survey_json.pages[0].elements;
      const question = elements.find(obj => obj.id === questionId)
      const choice = question.choices.find(obj => obj.id === optionId)

      return choice.text
  }

  function pdfToBase64(pdf) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = function() {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(pdf);
    });
  }


  const screeningData = {
    provider_id: providerId,
    template_id: template.survey_json.template_id,
    client: {
      first_name: requestor.first_name,
      last_name: requestor.last_name,
      date_of_birth: moment.unix(requestor.date_of_birth).utc().format('YYYY-MM-DD'),
      medicaid_id: requestor.medicaid_id,
      email_address: requestor.email_address || undefined,
      phone_number: requestor.phone_number ? {
        phone_number: requestor.phone_number,
        phone_type: 'unknown'
      } : undefined,
      address: _.pick(requestor, [...locationAddressFieldNames, 'address_type', 'line_2'])
    }
  };

  let answers = [];

  if(screening.form_response && screening.form_response.length > 0) {
      for(const response of screening.form_response) {
        for (const value of response.valueId) {
          answers.push({
            name: response.name,
            title: response.title,
            value: response.value,
            displayValue: response.displayValue,
            loinc_code: getLoincCode(response.id),
            id: response.id,
            valueId: value,
            option: {
              loinc_code: getLoincCode(response.id, value),
              text: getOptionTextById(response.id, value),
              id: value,
            }
          })
        }
      }
  }
  screeningData.answers = answers;

  const consentFileData = await pdfToBase64(pdfFile);
  const bundle = createFhirBundle(screeningData, consentFileData, requestData.widget_submission_ids ?? []);

  const baseURL = SCREENINGS_API;

  // Let axios errors (timeouts, 5xx, etc.) propagate so the caller can retry
  // and surface an error to the user.
  const response = await axios.post(
    'fhir/self-screen',
    bundle,
    {
      baseURL,
      timeout: SUBMISSION_TIMEOUT_MS,
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Scope-Id': providerId
      },
    },
  );

  return response;
};

export default createClientScreening;
